/* ═══════════════════════════════════════════════════════════
   ASTROITE — Generated localized content for the 108 Shakti
   Peeths and 12 Jyotirlingas. Keyed by peeth_id / jyotirlinga_id.

   The two datasets are authored in OPPOSITE languages, so each
   pack supplies only the NON-native languages; the native one
   comes straight from the DB record (see sites.js):

     • Peeths        — DB native = English.  Provide: hi, mr.
       (names/shakti/bhairava/body_part are bilingual in the DB
        and are split at runtime — no entry needed here.)
         1: { history: { hi, mr }, significance: { hi, mr } }

     • Jyotirlingas  — DB native = Hindi.     Provide: en, mr.
         1: { name:{en,mr}, shivaForm:{en,mr}, history:{en,mr}, significance:{en,mr} }

   Any field/language left absent falls back to the DB value, so
   the app is always correct — even with a partially-filled pack.

   ⚠ Generated translations — pending native-speaker review before
   production (sacred content).
   ═══════════════════════════════════════════════════════════ */

// Peeths: provide Hindi + Marathi for the English history/significance.
export const PEETH_TEXT = {
  // 1: { history: { hi: '…', mr: '…' }, significance: { hi: '…', mr: '…' } },
};

// Jyotirlingas: provide English + Marathi for the Hindi name/shivaForm/history/significance.
export const JYOTIRLINGA_TEXT = {
  // 1: { name: { en: 'Somnath', mr: 'सोमनाथ' }, shivaForm: {…}, history: {…}, significance: {…} },
};
